var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarYellow = function SvgStarYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9FC59",
    d: "M10.395 1.267a.502.502 0 0 1 .93 0l2.56 6.288a.502.502 0 0 0 .43.311l6.771.492a.502.502 0 0 1 .287.885l-5.189 4.378a.502.502 0 0 0-.163.504l1.624 6.592a.502.502 0 0 1-.752.547l-5.768-3.582a.502.502 0 0 0-.53 0l-5.767 3.582a.502.502 0 0 1-.752-.547L5.7 14.125a.502.502 0 0 0-.164-.504L.347 9.243a.502.502 0 0 1 .287-.885l6.772-.492a.502.502 0 0 0 .428-.311l2.561-6.288Z"
  })));
};
export default SvgStarYellow;